import React, { useContext } from "react";
import PropTypes from "prop-types";

import CameraFilterContext from "../../../CameraListing/CameraFilterContext";
import t from "../../../../../lib/translate";

import * as styles from "./select.module.less";
import { HtmlSelect } from "../../../../../components/form-components/FormField/SelectInput/Html";

function Select({ filterKey, settings = {}, options }) {
    const { replaceFilterOptionAction } = useContext(CameraFilterContext);
    const { emptyOptionLabelTranslation, labelTranslation } = settings;

    return (
        <div className={styles.selectContainer}>
            <span>{`${labelTranslation ? t(labelTranslation) : filterKey}`}</span>

            <HtmlSelect
                value={
                    options.find(({ active }) => active === true)?.value || ""
                }
                options={[
                    {
                        value: "",
                        label: emptyOptionLabelTranslation
                            ? t(emptyOptionLabelTranslation)
                            : "empty"
                    },
                    ...options
                ]}
                onChange={({ target: { value } }) =>
                    replaceFilterOptionAction(filterKey, value)
                }
            />
        </div>
    );
}

Select.defaultProps = {
    settings: {}
};

Select.propTypes = {
    filterKey: PropTypes.string.isRequired,
    settings: PropTypes.shape({
        labelTranslation: PropTypes.string,
        emptyOptionLabelTranslation: PropTypes.string
    }),
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            active: PropTypes.bool,
            disabled: PropTypes.bool
        })
    ).isRequired,
};

export { Select };
